import { render, staticRenderFns } from "./ArchiveDocument.vue?vue&type=template&id=1f3506a0&"
import script from "./ArchiveDocument.vue?vue&type=script&lang=js&"
export * from "./ArchiveDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports